<template>
  <div>
    <div class="search-panel">
      <a-button @click="supperSearchView">高级筛选</a-button>
      <template v-if="status !=='1'">
        <label style="margin-left: 10px">
          处理状态
        </label>
        <a-select style="width: 120px;margin-left: 10px" v-model="queryParam.handleStatus" allowClear placeholder="请选择">
          <a-select-option value="1" >未处理</a-select-option>
          <a-select-option value="2" >已处理</a-select-option>
        </a-select>
      </template>
      <template v-else>
        <a-radio-group style="margin-left: 10px" v-model="baseQueryParam.handleStatus" @change="searchQueryMy" >
          <a-radio-button :value="'1'">
            未处理
          </a-radio-button>
          <a-radio-button :value="'2'">
            已处理
          </a-radio-button>
        </a-radio-group>
      </template>

      <a-input class="search-item-com" v-model="queryParam.input" placeholder="请输入编号/姓名" style="width: 300px"></a-input>
      <a-button class="search-item-com" type="primary" @click="searchQueryMy">查询</a-button>
      <a-button class="search-item-com" @click="searchReset">重置</a-button>
    </div>
    <a-table
      ref="table"
      size="middle"

      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleView(record)">查看</a>
        </span>
      <span slot="handleStatus" slot-scope="text, record">
          <a-tag :color="handleStatusInfo[text].color">{{ handleStatusInfo[text].text }}</a-tag>
        </span>
      <span slot="questionStatus" slot-scope="text, record">
             <a-tag :color="questionStatusInfo[text].color">{{ questionStatusInfo[text].text }}</a-tag>
        </span>
    </a-table>
    <a-modal
      title="高级筛选"
      :width="1200"
      :visible="advancedVisible"
      @ok="handleAdvancedSubmit"
      @cancel="handleAdvancedCancel">
      <a-checkbox-group v-model="queryParam2.centerIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            研究中心：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(center,index) in centerList" :key="index">
                <a-checkbox :value="center.center.id">
                  {{center.center.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.userIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            研究员：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(user,index) in userList" :key="index">
                <a-checkbox :value="user.userId">
                  {{user.realname}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.periodItemIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            周期：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(periodItem,index) in periodItemList" :key="index">
                <a-checkbox :value="periodItem.id">
                  {{periodItem.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.formIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            表单：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6" v-for="(form,index) in formList" :key="index">
                <a-checkbox :value="form.id">
                  {{form.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.createTypeList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            质疑来源：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6">
                <a-checkbox value="系统">
                  系统
                </a-checkbox>
              </a-col>
              <a-col :span="6">
                <a-checkbox value="人工">
                  人工
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-row>
        <a-col :span="4" class="advanced-label">
          质疑发起日期：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.submitTimeList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction } from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'QuestionList',
    mixins: [JeecgListMixin],
    props:{
      status:{
        type:String,
        default:'1'
      }
    },
    data(){
      return{
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        advancedVisible:false,
        queryParam2:{},
        handleStatusInfo:{
          "1":{color: 'orange', text: '未处理'},
          "2":{color: '', text: '已处理'}
        },
        questionStatusInfo:{
          "1":{color: '', text: '未关闭'},
          "2":{color: 'green', text: '已关闭'}
        },
        columns:[
          {
            title: '编号',
            width: 120,
            dataIndex: 'patientNum',
          },
          {
            title: '受试者姓名',
            width: 120,
            dataIndex: 'patientName',
          },
          {
            title: '研究员',
            width: 100,
            dataIndex: 'userRealname',
          },
          {
            title: '周期',
            width: 100,
            dataIndex: 'periodItemName',
          },
          {
            title: '表单名称',
            width: 150,
            ellipsis: true,
            dataIndex: 'formName',
          },
          {
            title: '质疑对象',
            width: 150,
            ellipsis: true,
            dataIndex: 'formItemName',
          },
          {
            title: '质疑说明',
            width: 150,
            ellipsis: true,
            dataIndex: 'description',
          },
          {
            title: '处理状态',
            width: 100,
            ellipsis: true,
            dataIndex: 'handleStatus',
            scopedSlots: {customRender: 'handleStatus'}
          },
          {
            title: '处理详情',
            width: 150,
            ellipsis: true,
            dataIndex: 'info',
          },
          {
            title: '质疑状态',
            width: 100,
            ellipsis: true,
            dataIndex: 'status',
            scopedSlots: {customRender: 'questionStatus'}
          },
          {
            title: '质疑来源',
            width: 100,
            ellipsis: true,
            dataIndex: 'createType',
          },
          {
            title: '质疑发起人',
            width: 100,
            ellipsis: true,
            dataIndex: 'createName',
          },
          {
            title: '质疑发起时间',
            width: 150,
            ellipsis: true,
            dataIndex: 'createTime',
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 120,
            align: "center",
            fixed:'right',
            scopedSlots: {customRender: 'action'}
          }
        ],
        url:{
          list:'/question/patientQuestion/list'
        },
        centerList:[],
        userList:[],
        periodItemList:[],
        formList:[],
        disableMixinCreated:true,
      }
    },
    watch: {
      '$route.query.userId': {
        handler: function(newUserId, oldUserId) {
          console.log(`新的 userId: ${newUserId}, 旧的 userId: ${oldUserId}`);
          if (newUserId) {
            const baseQueryParam = {projectId:this.projectId,status:this.status}
            this.baseQueryParam = baseQueryParam
            this.$set(this.baseQueryParam,'supper',`{"userIdList":["${newUserId}"]}`)
            this.resetSupperParams()
            this.loadData()
            this.loadSearchData()
          }
        },
        immediate: true // 立即以当前值触发处理器
      }
    },
    mounted(){
      if (!this.$route.query.userId) {
        const baseQueryParam = {projectId:this.projectId,status:this.status}
        if(this.status==='1'){
          baseQueryParam.handleStatus = '1'
        }
        this.baseQueryParam = baseQueryParam
        this.resetSupperParams()
        this.loadData()
        this.loadSearchData()
      }
    },
    methods:{
      loadSearchData(){
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.centerList = res.result
          }
        })
        getAction('/project/projectUser/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.userList = res.result
          }
        })
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
        getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.formList=res.result
          }
        })
      },

      resetSupperParams(){
        this.$set(this.queryParam2,'centerIdList',[])
        this.$set(this.queryParam2,'userIdList',[])
        this.$set(this.queryParam2,'periodItemIdList',[])
        this.$set(this.queryParam2,'formIdList',[])
        this.$set(this.queryParam2,'createTypeList',[])
        this.$set(this.queryParam2,'submitTimeList',[])
        this.$set(this.queryParam,'supper',"")
      },
      searchQueryMy(){
        this.resetSupperParams()
        this.searchQuery()
      },
      handleView(record){
        this.$router.push({path:'/project/datacheck/checkform/'+record.formId})
      },
      handleAdvancedSubmit(){
        this.$set(this.queryParam,'handleStatus',null)
        this.$set(this.queryParam,'status',null)
        this.$set(this.queryParam,'input',null)
        this.$set(this.queryParam,'supper',JSON.stringify(this.queryParam2))
        this.loadData();
        this.handleAdvancedCancel()
      },
      handleAdvancedCancel(){
        this.advancedVisible = false
      },
      supperSearchView(){
        this.resetSupperParams()
        this.advancedVisible = true
      }
    }
  }
</script>

<style scoped lang="less">
  .search-panel{
    text-align: left;
    margin-bottom: 10px;
    .search-item-com{
      margin-left: 5px;
    }
  }
  .advanced-label{
    text-align: right;
  }
  .advanced-row{
    width: 100%;
    margin-bottom: 20px;
  }
</style>